import React from 'react';
import { Navigate } from 'react-router-dom';
import { useAuth } from '../contexts/AuthProvider';

/**
 * PrivateRoute component to protect routes that require authentication
 * Redirects to login page if user is not authenticated
 * If staffOnly is true, also checks if user is staff
 */
const PrivateRoute = ({ children, staffOnly = false }) => {
  const { user, loading } = useAuth();

  console.log('[PrivateRoute] loading:', loading, 'user:', user?.email || 'null');

  // Don't redirect while auth is still loading - prevents flash to login on refresh
  if (loading) {
    console.log('[PrivateRoute] Still loading, showing spinner');
    return (
      <div className="min-h-screen flex items-center justify-center bg-background">
        <div className="animate-spin rounded-full h-8 w-8 border-b-2 border-primary"></div>
      </div>
    );
  }

  if (!user) {
    console.log('[PrivateRoute] No user, redirecting to /login');
    return <Navigate to="/login" replace />;
  }

  if (staffOnly && !user.is_staff) {
    return <Navigate to="/products" replace />;
  }

  return children;
};

export default PrivateRoute;
